// extracted by mini-css-extract-plugin
export var aniSpin = "w_d";
export var base = "w_P";
export var base__bg = "w_Q";
export var base__frame = "w_R";
export var el = "w_b";
export var icon = "w_S";